import { createContext, useContext } from 'react';
import { type AuthContextType, type Profile } from '../types/auth';

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}

/**
 * Use this hook when you need guaranteed access to the profile
 * Throws an error if profile is not loaded
 */
export function useAuthWithProfile(): Omit<AuthContextType, 'profile'> & { profile: Profile } {
  const context = useAuth();
  if (!context.profile) {
    throw new Error('Profile is not loaded');
  }
  return {
    ...context,
    profile: context.profile as Profile,
  };
}